import { PermissionActions } from '@/features/permissions/permissionActions.js'
import SuperAdminDummyRouter from '@/features/superAdmin/SuperAdminDummyRouter.vue'

export const orgDisciplineManagementRoutes = [
  {
    path: 'organization-discipline-management',
    component: SuperAdminDummyRouter,
    meta: { permissionAction: PermissionActions.OrganisationDisciplinesView },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/settingsManagement/orgDisciplineManagement/list/OrgDisciplineListView.vue'),
        meta: { permissionAction: PermissionActions.OrganisationDisciplinesView },
      },
      {
        path: ':orgDisciplineId',
        component: () =>
          import('@/features/settingsManagement/orgDisciplineManagement/edit/OrgDisciplineEditView.vue'),
        meta: { permissionAction: PermissionActions.OrganisationDisciplinesView },
      },
      {
        path: 'new',
        component: () =>
          import('@/features/settingsManagement/orgDisciplineManagement/edit/OrgDisciplineEditView.vue'),
        meta: { permissionAction: PermissionActions.OrganisationDisciplinesCreate },
      },
    ],
  },
]
